import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';
import { debuglog } from 'util';
@Component({
  selector: 'app-filemaster-form',
  templateUrl: './filemaster-form.component.html',
  styleUrls: ['./filemaster-form.component.css']
})
export class FilemasterFormComponent implements OnInit {

  title="Add File";
  data : any = {};
  formInvalid : boolean = false;
  f : any = {};

  File_Id : number;
  mode : string;
  departmentlist : any = {}

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }
  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.File_Id = params['File_Id'];  
      this.mode  =   params['mode'];   
        
        if(this.File_Id > 0){
          this.GetFileById(this.File_Id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Case Proceedings";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Case Proceedings";
    }  


    //Get All departments
    this.data = this.userService.GetAllDepartments();
    this.data.subscribe(
    (response: any) => {
     this.departmentlist= response.Result;         
    })
  }

  SaveFile(File: NgForm){  
    debugger; 
    
    if(File.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.userService.PostFile(File.value);    
            this.data.subscribe(
            (response) => {
              File.reset();
              File.resetForm();
              File.form.markAsPristine();
              File.form.markAsUntouched();        
              swal('Success!', 'File Added Successfully .', 'success');
              this.router.navigate(['/home/filemaster']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetFileById(File_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdFile(File_Id);
        this.data.subscribe(
          (response: any) => {
            this.f = response;        
            
            console.log('Get By Id');
            console.log(this.f);
            console.log(response)
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateFile(File: NgForm) {  
    this.data = this.userService.UpdateFile(File.value,this.File_Id);
   this.data.subscribe(
     (response) => {
      File.reset();
      File.resetForm();
      File.form.markAsPristine();
      File.form.markAsUntouched();           
                   
       swal('Success!', 'File updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/filemaster']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){

this.f.File_Number='';
this.f.File_Name='';
this.f.File_Dep_Id_FK='';
}




  

}




// WEBPACK FOOTER //
// ./src/app/master/file-master/filemaster-form/filemaster-form.component.ts